import { render } from "./WidgetCategoryStats.vue?vue&type=template&id=75126633&scoped=true"
import script from "./WidgetCategoryStats.vue?vue&type=script&lang=js"
export * from "./WidgetCategoryStats.vue?vue&type=script&lang=js"

import "./WidgetCategoryStats.vue?vue&type=style&index=0&id=75126633&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75126633"],['__file',"src/components/Charts/WidgetCategoryStats.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "75126633"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('75126633', __exports__)) {
    api.reload('75126633', __exports__)
  }
  
  module.hot.accept("./WidgetCategoryStats.vue?vue&type=template&id=75126633&scoped=true", () => {
    api.rerender('75126633', render)
  })

}


export default __exports__